export const getSocketConfig = (token: string, language: string) => {
  const spamMode = localStorage.getItem("spamMode");
  const spamSystem = localStorage.getItem("spamSystem");
  const spamBonus = localStorage.getItem("spamBonus");
  return {
    token,
    spam: Boolean(spamMode),
    spamSystem: Boolean(spamSystem),
    spamBonus: Boolean(spamBonus),
    userLanguage: language.toLowerCase(),
  };
};
